import { render, staticRenderFns } from "./settlementManage.vue?vue&type=template&id=555e7465&scoped=true&"
import script from "./settlementManage.vue?vue&type=script&lang=js&"
export * from "./settlementManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555e7465",
  null
  
)

export default component.exports